import { render, staticRenderFns } from "./MapaMesas.vue?vue&type=template&id=5a147333&"
import script from "./MapaMesas.vue?vue&type=script&lang=js&"
export * from "./MapaMesas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports